import { request } from './client';

/**
 * 创建标签
 * @param {Object} payload - 标签数据
 */
export const createLabel = async (payload) => {
  return request('/labels', {
    method: 'POST',
    body: payload,
  });
};

/**
 * 获取标签列表
 * @param {Object} params - {pageNum, pageSize}
 */
export const fetchLabels = async ({ pageNum = 1, pageSize = 10 } = {}) => {
  return request('/labels', {
    method: 'GET',
    params: { pageNum, pageSize },
  });
};

/**
 * 获取标签详情
 * @param {number} id - 标签ID
 * @param {boolean} lite - 精简模式（不含大字段，用于快速首屏渲染）
 */
export const fetchLabelDetail = async (id, lite = false) => {
  return request(`/labels/${id}`, {
    method: 'GET',
    params: lite ? { lite: true } : undefined,
  });
};

/**
 * 获取单个内容项完整数据（用于懒加载）
 * @param {number} labelId - 标签ID
 * @param {string} itemId - 内容项ID
 */
export const fetchContentItem = async (labelId, itemId) => {
  return request(`/labels/${labelId}/content/${itemId}`, {
    method: 'GET',
  });
};

/**
 * 更新标签
 * @param {number} id - 标签ID
 * @param {Object} payload - 标签数据
 */
export const updateLabel = async (id, payload) => {
  return request(`/labels/${id}`, {
    method: 'PUT',
    body: payload,
  });
};

/**
 * 发布标签
 * @param {number} id - 标签ID
 */
export const publishLabel = async (id) => {
  return request(`/labels/${id}/publish`, {
    method: 'POST',
  });
};

/**
 * 克隆标签
 * @param {number} id - 标签ID
 */
export const cloneLabel = async (id) => {
  return request(`/labels/${id}/clone`, {
    method: 'POST',
  });
};

/**
 * 删除标签
 * @param {number} id - 标签ID
 */
export const deleteLabel = async (id) => {
  return request(`/labels/${id}`, {
    method: 'DELETE',
  });
};

/**
 * 生成二维码
 * @param {number} id - 标签ID
 */
export const generateQRCode = async (id) => {
  return request(`/labels/${id}/qrcode`, {
    method: 'GET',
  });
};

/**
 * 获取二维码基础URL配置
 */
export const getQRCodeBaseUrl = async () => {
  return request(`/labels/config/qrcode-base-url`, {
    method: 'GET',
  });
};
